module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "se-detail-section"
  }, [_c('div', {
    staticClass: "se-detail-h"
  }, [_vm._v("Properties")]), _vm._v(" "), _c('div', {
    staticClass: "se-kv"
  }, [_c('span', {
    staticClass: "k"
  }, [_vm._v("Type")]), _c('span', {
    staticClass: "v"
  }, [_vm._v(_vm._s(_vm.stage.stageType))])]), _vm._v(" "), _c('div', {
    staticClass: "se-kv"
  }, [_c('span', {
    staticClass: "k"
  }, [_vm._v("Media")]), _c('span', {
    staticClass: "v"
  }, [_vm._v(_vm._s(_vm.stage.mediaType))])]), _vm._v(" "), (_vm.stage.inputType) ? _c('div', {
    staticClass: "se-kv"
  }, [_c('span', {
    staticClass: "k"
  }, [_vm._v("Input")]), _c('span', {
    staticClass: "v"
  }, [_vm._v(_vm._s(_vm.stage.inputType))])]) : _vm._e(), _vm._v(" "), (_vm.stage.endsChat) ? _c('div', {
    staticClass: "se-kv"
  }, [_c('span', {
    staticClass: "k"
  }, [_vm._v("Ends chat")]), _c('span', {
    staticClass: "v"
  }, [_vm._v("Yes")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "se-detail-section"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "se-hint"
  }, [_vm._v("Phrases the NLP model matches against user questions to route them into this stage.")]), _vm._v(" "), _c('div', {
    staticClass: "se-tag-chips"
  }, _vm._l((_vm.stage.topics), function(t, i) {
    return _c('span', {
      key: i,
      staticClass: "se-tag-chip"
    }, [_vm._v("\n        " + _vm._s(t)), _c('button', {
      staticClass: "se-tag-x",
      attrs: {
        "title": "Remove"
      },
      on: {
        "click": function($event) {
          return _vm.removeTopic(i)
        }
      }
    }, [_vm._v("×")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "se-tag-add-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topicInput),
      expression: "topicInput"
    }],
    staticClass: "se-tag-input",
    attrs: {
      "placeholder": "Add a phrase or question..."
    },
    domProps: {
      "value": (_vm.topicInput)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.addTopic.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.topicInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "se-mini-btn",
    on: {
      "click": _vm.addTopic
    }
  }, [_vm._v("+ Add")]), _vm._v(" "), _c('button', {
    staticClass: "se-mini-btn",
    on: {
      "click": _vm.generateTopics
    }
  }, [_vm._v("✨ Generate")])])]), _vm._v(" "), (_vm.stage.availableLangs && _vm.stage.availableLangs.length) ? _c('div', {
    staticClass: "se-detail-section"
  }, [_c('div', {
    staticClass: "se-detail-h"
  }, [_vm._v("Message")]), _vm._v(" "), _c('div', {
    staticClass: "se-lang-chips"
  }, _vm._l((_vm.stage.availableLangs), function(l) {
    return _c('button', {
      key: l,
      staticClass: "se-lang-chip",
      class: {
        active: _vm.detailLang === l
      },
      on: {
        "click": function($event) {
          _vm.detailLang = l
        }
      }
    }, [_vm._v(_vm._s(_vm.langLabel(l)))])
  }), 0), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messageDraft),
      expression: "messageDraft"
    }],
    staticClass: "se-msg-box se-msg-edit",
    attrs: {
      "rows": "6"
    },
    domProps: {
      "value": (_vm.messageDraft)
    },
    on: {
      "blur": _vm.commitMessage,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messageDraft = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.stage.options) ? _c('div', {
    staticClass: "se-detail-section"
  }, [_c('div', {
    staticClass: "se-detail-h"
  }, [_vm._v("Options → next")]), _vm._v(" "), _c('table', {
    staticClass: "se-opt-table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.stage.options), function(o, i) {
    return _c('tr', {
      key: i
    }, [_c('td', [_c('span', {
      staticClass: "se-opt-slug"
    }, [_vm._v(_vm._s(o.opt))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "se-next-row"
    }, [_c('nv-select', {
      staticClass: "se-next-select",
      attrs: {
        "value": o.next || ''
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("— choose —")]), _vm._v(" "), _vm._l((_vm.stageNames), function(name) {
      return _c('option', {
        key: name,
        domProps: {
          "value": name
        }
      }, [_vm._v(_vm._s(name))])
    })], 2), _vm._v(" "), (o.next) ? _c('button', {
      staticClass: "se-jump-btn",
      attrs: {
        "title": "Open this stage"
      },
      on: {
        "click": function($event) {
          return _vm.$emit('select-stage', o.next)
        }
      }
    }, [_vm._v("↗")]) : _vm._e()], 1)])])
  }), 0)])]) : (_vm.stage.next) ? _c('div', {
    staticClass: "se-detail-section"
  }, [_c('div', {
    staticClass: "se-detail-h"
  }, [_vm._v("Next")]), _vm._v(" "), _c('div', {
    staticClass: "se-next-row"
  }, [_c('nv-select', {
    staticClass: "se-next-select",
    attrs: {
      "value": _vm.stage.next
    }
  }, _vm._l((_vm.stageNames), function(name) {
    return _c('option', {
      key: name,
      domProps: {
        "value": name
      }
    }, [_vm._v(_vm._s(name))])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "se-jump-btn",
    attrs: {
      "title": "Open this stage"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('select-stage', _vm.stage.next)
      }
    }
  }, [_vm._v("↗")])], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "se-detail-h"
  }, [_vm._v("Topic mapping "), _c('span', {
    staticClass: "se-ai-chip"
  }, [_vm._v("✨ AI generated")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Option")]), _c('th', [_vm._v("Next stage")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0642a54f","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-journey/journey-flow/StageContentTab.vue
// module id = mXB0
// module chunks = 1